export enum UnitStatusEnum {
    UNMARKED = 'UNMARKED',
    UNDERSTOOD = 'UNDERSTOOD',
    SKIPPED = 'SKIPPED'
}
